var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.975 13.5H21v-2h-4.025c-.25-5.053-2.382-9-4.975-9-2.593 0-4.724 3.947-4.975 9H3v2h4.025c.25 5.053 2.382 9 4.975 9 2.593 0 4.724-3.947 4.975-9zm-2.002 0c-.116 2.094-.587 3.899-1.226 5.177C12.948 20.274 12.215 20.5 12 20.5c-.215 0-.948-.226-1.747-1.823-.639-1.278-1.11-3.083-1.226-5.177h5.946zm-5.946-2c.116-2.094.587-3.899 1.226-5.177C11.052 4.726 11.785 4.5 12 4.5c.215 0 .948.226 1.747 1.823.639 1.278 1.11 3.083 1.226 5.177H9.027z",
    fill: "#61676e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0 2c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z",
    fill: "#61676e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLanguageIcon);
export default __webpack_public_path__ + "static/media/icon_language-icon.97632e866b02f0806414eda7f4341227.svg";
export { ForwardRef as ReactComponent };